import { render, staticRenderFns } from "./ImportFiscalManageView.vue?vue&type=template&id=708e2674&scoped=true"
import script from "./ImportFiscalManageView.vue?vue&type=script&lang=js"
export * from "./ImportFiscalManageView.vue?vue&type=script&lang=js"
import style0 from "./ImportFiscalManageView.vue?vue&type=style&index=0&id=708e2674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e2674",
  null
  
)

export default component.exports